<auto-reload></auto-reload>
<div class="main__content">
  <div class="admin__header__background header__background"></div>
  <mat-sidenav-container class="admin__sidenav">
    <mat-sidenav
      #sidenav
      [disableClose]="isSidenavOpen"
      [mode]="sidenavMode"
      [opened]="isSidenavOpen"
    >
      <user-info
        (click)="toggleUserSettings()"
        data-e2e="user-info-fragment"
      ></user-info>
      <admin-sidenav></admin-sidenav>
    </mat-sidenav>
    <div class="my-content">
      <mat-toolbar class="main__toolbar">
        <div class="header-container">
          <app-header (isNavShown)="toggleSidenav()"></app-header>
        </div>
      </mat-toolbar>
      <page-content class="page-content">
        <router-outlet></router-outlet>
      </page-content>
    </div>
  </mat-sidenav-container>
</div>

<div class="main__footer">
  <app-footer></app-footer>
</div>
